import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  itineraryroot: {
    maxWidth: 1080,
    marginBottom: 24,
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    [Theme.breakpoints.up('md')]: {
      paddingLeft: 40,
      paddingRight: 40,
    },
    [Theme.breakpoints.up('xl')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },

    '& h6': {
      color: Theme.palette.text.brand,
      fontWeight: 'normal',
    },

    '& .itinerary-items': {
      display: 'none',
      [Theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    '& .items': {
      display: 'flex',
      gap: '10px 20px',
      flexWrap: 'wrap',
      color: Theme.palette.gray[750],
      flexDirection: 'column',

      [Theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },

    '& .label': {
      display: 'inline-block',
      paddingRight: 4,
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.text.brand,
    },
    '& span': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& .cruise-dates': {
      display: 'flex',
      '& span:last-of-type': {
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      },
      '& svg': {
        width: 12,
        height: 12,
        [Theme.breakpoints.up('lg')]: {
          width: 16,
          height: 16,
        },
      },
    },

    '& a': {
      color: Theme.palette.primary.light,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
      margin: 0,
    },
  },
  stretch: {
    maxWidth: 1440,
    [Theme.breakpoints.up('lg')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
}));

export default useStyles;
